module.exports = __webpack_public_path__ + "fonts/NotoSansKR-Regular.754a10f6.woff2";